import { Badge } from '../../components/Badge';
import { MobileListItemConfig } from '../../components/data-display/ResponsiveDataView/types';
import { NotificationStateIcon } from '../../components/notifications';
import { NotificationEvent } from '../../gql/generated';
import {
  formatChannelNames,
  formatNotificationDate,
  notificationStateLabel,
  notificationStateVariant,
} from '../../utils/notificationFormatters';
import { notificationThresholdLabel } from '../../utils/notificationMembers';

interface NotificationListItemMobileProps {
  event: NotificationEvent;
  config: MobileListItemConfig<NotificationEvent>;
}

export function NotificationListItemMobile({
  event,
  config,
}: NotificationListItemMobileProps) {
  const channelNames = formatChannelNames(event.notificationDeliveries);
  const thresholdText = notificationThresholdLabel(event);

  return (
    <div
      className='border-border-primary bg-white px-4 py-4'
      role='button'
      tabIndex={0}
      onClick={() => config.onClick?.(event)}
      onKeyDown={(eventKeyboard) => {
        if (eventKeyboard.key === 'Enter' || eventKeyboard.key === ' ') {
          eventKeyboard.preventDefault();
          config.onClick?.(event);
        }
      }}
      aria-label={`Notification ${event.subject || 'item'}`}
    >
      <div className='flex items-center justify-between gap-3'>
        <div className='flex min-w-0 flex-col gap-1'>
          <div className='flex items-center gap-1.5'>
            <NotificationStateIcon state={event.alarmTriggerState} />
            <span className='size-p2 text-primary truncate font-medium'>
              {event.machineName || 'Unknown machine'}
            </span>
          </div>
          <div className='size-caption text-tertiary'>
            {formatNotificationDate(event.timeUtc)}
            {thresholdText ? ` · ${thresholdText}` : ''}
          </div>
        </div>
        <Badge variant={notificationStateVariant[event.alarmTriggerState]}>
          {notificationStateLabel[event.alarmTriggerState]}
        </Badge>
      </div>

      <div className='text-secondary size-caption mt-2 flex flex-wrap gap-2'>
        <span>Success: {event.successfulDeliveries ?? 0}</span>
        <span>Failed: {event.failedDeliveries ?? 0}</span>
      </div>

      {event.subject && (
        <div className='size-caption text-secondary mt-2 truncate'>
          {event.subject}
        </div>
      )}

      {channelNames && (
        <div className='size-caption text-secondary mt-2'>
          Channels: {channelNames}
        </div>
      )}
    </div>
  );
}
